import { TOUR_GUILD_HIDDEN, TOUR_GUILD_SHOW } from "./action.type";
import { HiddenTourGuild, ShowTourGuild } from "./types";

export const showTourGuild = (): ShowTourGuild => ({
  type: TOUR_GUILD_SHOW,
});

export const hideTourGuild = (): HiddenTourGuild => ({
  type: TOUR_GUILD_HIDDEN,
});
